<div class="login-form-flex">
    <mat-card appearance="outlined" class="single">
        <mat-card-header>
            <mat-card-title>{{ 'login.passwordForgotten.title' | translate }}</mat-card-title>
        </mat-card-header>
        <form [formGroup]="emailForm" (ngSubmit)="submit()">
            <mat-card-content>
                @if (!!message) {
                    <div>{{ message | translate }}</div>
                }
                <mat-form-field class="field">
                    <input matInput placeholder="{{'login.passwordForgotten.form.email' | translate}}" type="text"
                           formControlName="email" required
                           [attr.disabled]="waitingForResponse || completed">
                </mat-form-field>
            </mat-card-content>
            <mat-card-actions class="centered-button-container">
                <div class="button-flex-container">
                    <button mat-raised-button color="primary" type="submit"
                            [attr.disabled]="waitingForResponse || completed"
                            class="btn btn-primary">
                        {{ 'buttons.send' | translate }}
                    </button>
                    <br/><br/>
                    <a class="btn btn-primary" (click)="back()">
                        {{ 'buttons.back' | translate }}
                    </a>
                </div>
            </mat-card-actions>
        </form>
    </mat-card>
</div>
